import { MutationTree } from 'vuex'
import { IEventsState, IDataLayer } from '@/@types'

const mutations: MutationTree<IEventsState> = {
  UPDATE_UTM_PARAMS: (state, params: object) => {
    state.utmParams = params
  },
  UPDATE_DATA_LAYER: (state, dataLayer: IDataLayer) => {
    state.dataLayer = { ...state.dataLayer, ...dataLayer }
  },
}

export default mutations
